import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import customAxios from "../utils/customAxios";
import "../scss/Elements/_tables.scss"

import ModalEqAtt from "../components/Modal/Create/ModalEqAtt";
import { Autocomplete, Divider, TextField } from "@mui/material";
import { GlobalVariables } from "../globalVar";
import { getToast } from "../utils/toastConfig";

function EquipAttr() {
  const [brandsData, setBrandsData] = useState([]);

  useEffect(() => {
    customAxios.get(`${GlobalVariables.getURL()}autofillBrands`, {
      headers: {
        'Authorization': 'bearer ' + localStorage.getItem('token')
      }
    })
      .then((response) => {
        setBrandsData(response.data);
      })
      .catch(error => console.log(error));
  }, []);

  const [name, setName] = useState("");
  const [brandId, setBrand] = useState("");
  const [description, setDescription] = useState("");

  function createEquipment() {

    customAxios.post(`${GlobalVariables.getURL()}createEquip`, { // url to POST
      name: name,
      brand_id: brandId,
      description: description,
    }, {
      headers: {
        'Authorization': 'bearer ' + localStorage.getItem('token')
      }
    })
      .then((response) => {
        const equipId = JSON.stringify(response.data.createdEquipID);
        localStorage.setItem('equipIdForAtt', equipId)
        getToast({ status: 'success', title: 'Atributo del tipo de equipo creado exitosamente en la base de datos.' });
      }, (error) => {
        console.log(error);
        getToast({ status: 'error', title: 'Error al crear atributo del tipo de equipo. Vuelve a intentarlo.' })
      }).finally(console.log())

  }

  return (
    <div className="list">
      <div className="listContainer">
        <div className="equip-form-container">
          <Divider>Nuevo tipo de equipo</Divider>
          <form id="equip-form-id" onSubmit={createEquipment}>
          <br />
            <div className="row">
              <div className="col-md-5">
                <TextField 
                  sx={{ width: "100%" }}
                  label="Nombre del tipo de equipo"
                  type="text"
                  value={name} onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-5">
                <Autocomplete 
                  sx={{ width: "100%" }}
                  disablePortal
                  includeInputInList={false}
                  options={brandsData}
                  getOptionLabel={(brandsData) => brandsData.brand_name}
                  getOptionSelected={(brandsData, value) => brandsData.id === value.id}
                  renderInput={(params) => <TextField {...params} label="Seleccionar marca..." required/>}
                  onChange={(event, newValue) => {
                    setBrand(newValue.id);
                  }}
                />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-md-10">
                <TextField 
                  multiline
                  sx={{ width: "100%" }}
                  label="Descripción"
                  rows={4.5}
                  type="text"
                  value={description} onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          <br />
          </form>
          <div className="button-container">
            <button type="submit" form="equip-form-id" className="save-button">Guardar</button>
          </div>
        </div>

        <br/>
        <Divider>Atributos del tipo de equipo</Divider>

        <div className="attributes-container">
          
        </div>
      </div>
    </div>
  );
}

export default EquipAttr;